#import "./CanvasBlockBaseFields.graphql"
#import "./TextBlockFields.graphql"
#import "./MeetingSummaryBlockFields.graphql"
#import "./ListBlockFields.graphql"
#import "./DocumentsBlockFields.graphql"
#import "./ScheduleMeetingBlockFields.graphql"
#import "./RichTextBlockFields.graphql"
#import "./MetricBlockFields.graphql"
#import "./ChartBlockFields.graphql"

fragment CanvasBlockFields on CanvasBlockInterface {
  ...CanvasBlockBaseFields
  ...TextBlockFields
  ...MeetingSummaryBlockFields
  ...ListBlockFields
  ...DocumentsBlockFields
  ...ScheduleMeetingBlockFields
  ...RichTextBlockFields
  ...MetricBlockFields
  ...ChartBlockFields
}
